import './User.scss';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as storage from '../utils/storage';
import { buildUrl } from '../utils/helper';
import withRouter from "../utils/withRouter";
import Slide from '../animation/Slide';
import ManualWrapper from './ManualWrapper';

/**
 * User component
 * @module
 * @param {object} [uzivatel] - User object
 * @param {element} [brand] - Brand element
 * @param {func} onSignOut - Function invoked on sign out
 * @param {element} [userInfo] - User info element
 * @param {func} [getManual] - Function to get manual
 * @param {func} [getListManual] - Function to get manual list
 * @param {manualProps} [manualProps] - Props for manual
 */
const User = (props) => {
  const [showInfo, setShowInfo] = useState(false);
  const [showNotifikacie, setShowNotifikacie] = useState(false);
  const [isManualDialogOpen, setIsManualDialogOpen] = useState(false);
  const [isManualListOpen, setIsManualListOpen] = useState(false);
  const [isManualCustomOpen, setIsManualCustomOpen] = useState(false);

  const handleInfo = () => {
    setShowInfo(true);
  }

  const handleCloseInfo = () => {
    setShowInfo(false);
  }

  const handleManualDialogClose = () => {
    setIsManualDialogOpen(false);
  }

  const handleManualListClose = () => {
    setIsManualListOpen(false);
  }

  const handleManualCustomClose = () => {
    setIsManualCustomOpen(false);
  }

  // rozhodnutie ci sa pouzije dialog pre zobrazenie jedneho manualu
  // alebo manualList pre viacero manualov
  // alebo manualu s custom obsahom
  const handleNapoveda = () => {
    const manualProps = props.manualProps;

    if (manualProps && manualProps.hasList) {
      setIsManualListOpen(true);
    } else if (manualProps && manualProps.hasCustom) {
      setIsManualCustomOpen(true);
    } else {
      setIsManualDialogOpen(true);
    }
  }

  const handleSpravy = () => {
    if (props.getMessages) {
      return props.getMessages();
    }
  }

  const handleNotifikacie = () => {
    setShowNotifikacie(true);
  }

  const handleCloseNotifikacie = () => {
    setShowNotifikacie(false);
  }

  const handleLogout = () => {
    props.navigate({ pathname: "/" });
    storage.removeUser();
    props.onSignOut();
  }

  const buildInicialy = () => {
    const { uzivatel } = props;
    if (uzivatel && uzivatel.CeleMeno && uzivatel.Skratka) {
      return (
        <>
          <div className='fullname'>{uzivatel.CeleMeno}</div>
          <div className='shortcut'>{uzivatel.Skratka}</div>
        </>
      );
    } else if (uzivatel && !uzivatel.Skratka && uzivatel.CeleMeno) {
      let initials = (uzivatel.CeleMeno.split(' ').map(x => { return x.substring(0, 1) })).join("");
      return (
        <>
          <div className='fullname'>{uzivatel.CeleMeno}</div>
          <div className='shortcut'>{initials}</div>
        </>
      );
    } else if (uzivatel && uzivatel.Skratka && !uzivatel.CeleMeno) {
      return (
        <>
          <div className='shortcut'>{uzivatel.Skratka}</div>
        </>
      );
    }

    if (!uzivatel) {
      return 'x';
    }
  }

  const { uzivatel } = props;

  const infoOkno = (
    <div className="info-okno">
      <div className="nav_initials">
        <div className="inicialization-icone">
          {buildInicialy()}
        </div>
      </div>
      <div className="example-2">
        {uzivatel && uzivatel.CeleMeno &&
          <div className="meno-user">
            {uzivatel.CeleMeno}
          </div>
        }
        {uzivatel && !uzivatel.CeleMeno &&
          <div className="meno-user">
            {uzivatel.Meno} {uzivatel.Priezvisko}
          </div>
        }
        {props.userInfo}
      </div>
      <div className="nav_button_logout">
        <div className="logout" onClick={handleLogout}>
          Odhlásiť sa
        </div>
      </div>
    </div>
  );

  const notifikacieOkno = () => {
    if (props.getNotifications) {
      return props.getNotifications();
    }
    else {
      return (
        <div className="info-okno">
          Žiadne notifikácie
        </div >
      );
    }

  }

  return (
    <div className="nav-user">
      <div className="nav-icon" onClick={props.handleOpenSettings}>
        <img alt="presentation" src={buildUrl('assets/icons/nav_cg_setting.svg')}></img>
      </div>
      {(props.getManual || props.getListManual) &&
        <div className="nav-icon" onClick={handleNapoveda}>
          <img alt="presentation" src={buildUrl('assets/icons/nav_cg_manual.svg')}></img>
        </div>
      }
      {(props.getMessages) &&
        <div className="nav-icon" onClick={handleSpravy}>
          <img alt="presentation" src={buildUrl('assets/icons/nav_cg_spravy.svg')}></img>
        </div>
      }
      {(props.getNotifications) &&
        <div className="nav-icon" onClick={handleNotifikacie}>
          <img alt="presentation" src={buildUrl('assets/icons/nav_cg_zvoncek.svg')}></img>
        </div>
      }
      <div className="inicialy-user" onClick={handleInfo}>
        {buildInicialy()}
      </div>
      <Slide isOpen={showNotifikacie} onClose={handleCloseNotifikacie}>{notifikacieOkno()}</Slide>
      <Slide isOpen={showInfo} onClose={handleCloseInfo}>{infoOkno}</Slide>
      {props.manualProps &&
        <ManualWrapper
          manualProps={props.manualProps}
          getManual={props.getManual}
          getListManual={props.getListManual}
          isManualOpen={isManualDialogOpen}
          onManualClose={handleManualDialogClose}
          isListOpen={isManualListOpen}
          onListClose={handleManualListClose}
          isCustomOpen={isManualCustomOpen}
          onCustomClose={handleManualCustomClose}
        />
      }
    </div>
  );
}

User.propTypes = {
  uzivatel: PropTypes.object,
  onSignOut: PropTypes.func.isRequired,
  userInfo: PropTypes.element,
  getManual: PropTypes.func,
  getListManual: PropTypes.func,
  getMessages: PropTypes.func,
  getNotifications: PropTypes.func,
  manualList: PropTypes.element,
  manualProps: PropTypes.shape({
    hasList: PropTypes.bool.isRequired,
    hasCustom: PropTypes.bool,
    manualCustom: PropTypes.arrayOf(PropTypes.object),
    listManual: PropTypes.object,
    user: PropTypes.object,
    manualBlob: PropTypes.object,
    manualFileName: PropTypes.string,
    manualTitle: PropTypes.string,
    manualList: PropTypes.arrayOf(PropTypes.object),
    manualListData: PropTypes.array,
    manualListDataMap: PropTypes.object
  })
}

export default withRouter(User);
